import React, { useState } from 'react'
import Tabs, { TabPanel, TabTrigger, TabTriggerGroup } from '@zera-admin/tabs'
import { Column, Row } from '@zera-admin/page'
import Input from '@zera-admin/input'
import Switch from '@zera-admin/switch'
import Select, { SelectOptionProps } from '@zera-admin/select'
import { string } from '@zera-admin/helpers'

import { getFieldOptions } from 'bi-tool/visualizations/visualization/getters'

import * as Styled from './TweetDefinitions.styled'
import { TweetDefinitionsProps } from './types'
import { TWEET_FIELDS, TWEET_USER_FIELDS } from './constants'

const TweetDefinitions: React.FunctionComponent<TweetDefinitionsProps> = ({
  aggregations,
  fields,
  groups,
  onChange,
  options,
}) => {
  const [fieldOptions, setFieldOptions] = useState<SelectOptionProps[]>(
    getFieldOptions(fields)
  )

  const handleChangeFieldInput = (value: string) => {
    const option = {
      label: value,
      value,
    }
    const index = fieldOptions.findIndex(
      (reference) => reference.value === parseInt(option.value)
    )
    let optionsInstance = [...fieldOptions]

    if (value && index === -1) {
      optionsInstance[0] = option
    } else {
      optionsInstance = getFieldOptions(fields)
    }

    setFieldOptions(optionsInstance)
  }

  const renderTabs = () => {
    return (
      <Tabs id="tabs">
        <TabTriggerGroup>
          <TabTrigger>Veri / Tweet</TabTrigger>
          <TabTrigger>Veri / Kullanıcı</TabTrigger>
          <TabTrigger>Parametreler</TabTrigger>
        </TabTriggerGroup>
        <TabPanel>{renderTweetTab()}</TabPanel>
        <TabPanel>{renderUserTab()}</TabPanel>
        <TabPanel>{renderParametersTab()}</TabPanel>
      </Tabs>
    )
  }

  const renderParametersTab = () => {
    return (
      <Row xs={{ direction: 'column' }}>
        <Column>
          <Switch
            name="live"
            label="Anlık güncelleme"
            isChecked={options?.stream?.live}
            onChange={(event) =>
              onChange({
                ...options,
                stream: {
                  live: event.target.checked,
                  limit: 100,
                  interval: 60000,
                  timeout: 5000,
                },
              })
            }
          />
        </Column>
        {options?.stream?.live && (
          <React.Fragment>
            <Column>
              <Input
                name="interval"
                label="İstek aralığı (MS)"
                placeholder="60000"
                type="number"
                value={options?.stream?.interval}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  onChange({
                    ...options,
                    stream: {
                      ...options.stream,
                      interval: Number(event.target.value),
                    },
                  })
                }
              />
            </Column>
            <Column>
              <Input
                name="timeout"
                label="Yeni kayıt ekleme aralığı (MS)"
                placeholder="5000"
                type="number"
                value={options?.stream?.timeout}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  onChange({
                    ...options,
                    stream: {
                      ...options.stream,
                      timeout: Number(event.target.value),
                    },
                  })
                }
              />
            </Column>
            <Column>
              <Input
                name="limit"
                label="Gösterilecek kayıt sayısı"
                placeholder="100"
                type="number"
                value={options?.stream?.limit}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  onChange({
                    ...options,
                    stream: {
                      ...options.stream,
                      limit: Number(event.target.value),
                    },
                  })
                }
              />
            </Column>
          </React.Fragment>
        )}
      </Row>
    )
  }

  const renderTweetTab = () => {
    const values = options?.fields || {}

    return TWEET_FIELDS.map((tweetField, index) => (
      <Row key={index} xs={{ direction: 'column' }}>
        <Column>
          <Select
            name={tweetField.value}
            options={fieldOptions}
            onChange={(props) => {
              onChange({
                ...options,
                fields: {
                  ...options.fields,
                  [tweetField.value]: (props as SelectOptionProps)
                    .value as string,
                },
              })
            }}
            onInputChange={handleChangeFieldInput}
            value={
              values[tweetField.value]
                ? {
                    label: string.textify(values[tweetField.value]),
                    value: values[tweetField.value],
                  }
                : { label: '', value: '' }
            }
            label={tweetField.label}
            placeholder="Seçim yapınız"
          />
        </Column>
      </Row>
    ))
  }

  const renderUserTab = () => {
    const values = options?.fields || {}

    return TWEET_USER_FIELDS.map((tweetUserField, index) => (
      <Row key={index} xs={{ direction: 'column' }}>
        <Column>
          <Select
            name={tweetUserField.value}
            options={fieldOptions}
            onChange={(props) => {
              onChange({
                ...options,
                fields: {
                  ...options.fields,
                  [tweetUserField.value]: (props as SelectOptionProps)
                    .value as string,
                },
              })
            }}
            onInputChange={handleChangeFieldInput}
            value={
              values[tweetUserField.value]
                ? {
                    label: string.textify(values[tweetUserField.value]),
                    value: values[tweetUserField.value],
                  }
                : { label: '', value: '' }
            }
            label={tweetUserField.label}
            placeholder="Seçim yapınız"
          />
        </Column>
      </Row>
    ))
  }

  return <Styled.TweetDefinitions>{renderTabs()}</Styled.TweetDefinitions>
}

export default TweetDefinitions
